/**Dependencies */
import { useEffect, useRef, useState } from "react";
import { Accordion, Button, Col, Row } from "react-bootstrap";
import { Link, useNavigate, useLocation  } from "react-router-dom";

/**Components */
import { ReservationTimer } from "../components/ReservationTimer";

/**Images */
import EmptyCart from "../images/EmptyCart.png";
/**Styles */
import "../styles/components/Preventa.scss";

/**Services */

// Helpers
import {
  Currency,
  fetchMarkup,
  FormatCancellationPolicies,
  FormatDate,
  FormatHours,
} from "../helpers";
import { ScrollToTopRoute } from "../components/ScrollToTopRoute";

export const Preventa = () => {
  const [dataCart, setDataCart] = useState(() => {
    const storedData = sessionStorage.getItem("datosReserva");
    return storedData ? JSON.parse(storedData) : [];
  });
  const [dataUrl, setDataUrl] = useState("");
  const [totalReserva, setTotalReserva] = useState(0);
  const [totalHospedaje, setTotalHospedaje] = useState(0);
  const [totalActividades, setTotalActividades] = useState(0);
  const [totalTraslados, setTotalTraslados] = useState(0);
  const [markup, setMarkup] = useState(0);
  const [markupAct, setMarkupAct] = useState("");
  const [nights, setNights] = useState(0);
  const [checkRates, setCheckRates] = useState();
  const [show, setShow] = useState(false);
  const [messageButton, setMessageButton] = useState("");
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, []);

  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("hoteleria");
        setMarkup(markupData?.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);
  useEffect(() => {
    const fetchMarkupPanelAct = async () => {
      try {
        const markupData = await fetchMarkup("experiencias");
        setMarkupAct(markupData?.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanelAct();
  }, []);

  useEffect(() => {
    // Calcular cada total independientemente
    const hospedaje = Number(precioHospedajes());
    const actividades = Number(precioActivades());
    const traslados = Number(precioTraslados());

    // Sumar solo los que tienen valor mayor a 0
    const totalReserva = [hospedaje, actividades, traslados]
      ?.filter((price) => price > 0)
      ?.reduce((sum, price) => sum + price, 0);

    // Actualizar todos los estados en una sola operación
    setTotalReserva(totalReserva);
    setTotalHospedaje(hospedaje);
    setTotalActividades(actividades);
    setTotalTraslados(traslados);
  }, [dataCart]);

  useEffect(() => {
    if (dataCart) {
      const nights = dataCart?.hospedaje?.reduce(
        (total, item) => total + Number(item?.noches),
        0
      );
      setNights(nights);
    }
  }, [dataCart]);

  useEffect(() => {
    // Asegurar que dataCart tenga la estructura correcta, incluso si viene malformada
    const { hospedaje = [], actividades = [], traslados = [] } = dataCart || {};

    // Caso 1: Solo tiene hospedaje
    if (
      hospedaje?.length > 0 &&
      actividades?.length === 0 &&
      traslados?.length === 0
    ) {
      setDataUrl(
        `/experiencias-resultado?t=destination&id=${
          hospedaje?.[0]?.codedestino
        }&in=${hospedaje?.[0]?.checkIn}&out=${hospedaje?.[0]?.checkOut}&pax=${
          hospedaje?.[0]?.paxes?.[0]?.num_adultos
        }|21,21|${
          hospedaje?.[0]?.paxes?.[0]?.num_menores
        }|${hospedaje?.[0]?.paxes?.[0]?.edad_menores.replace("|", ",")}`
      );
      setMessageButton("Descubre experiencias para tu viaje");

      // Caso 2: Solo tiene actividades
    } else if (
      actividades?.length > 0 &&
      hospedaje?.length === 0 &&
      traslados?.length === 0
    ) {
      console.log("Actividades", actividades);
      console.log("Actividades", hospedaje);
      setDataUrl(
        `/alojamientos?t=destino&id=${actividades?.[0]?.codedestino}&in=${
          actividades?.[0]?.checkin
        }&out=${actividades?.[0]?.checkout}&hab=1&pax1=${
          actividades?.[0]?.paxes?.[0]?.adults
        }|${
          actividades?.[0]?.paxes?.[0]?.minors
        }|${actividades?.[0]?.paxes?.[0]?.ages?.map((age) => age).join(",")}`
      );
      setMessageButton("Descubre hoteles para tu viaje");

      // Caso 3: Solo tiene traslados
    } else if (
      traslados?.length > 0 &&
      hospedaje?.length === 0 &&
      actividades?.length === 0
    ) {
      setDataUrl("/");
      setMessageButton("¿Quieres agregar un hotel o experiencia?");

      // Caso 4: Tiene hospedaje + actividades (traslados no importa)
    } else if (hospedaje?.length > 0 && actividades?.length > 0) {
      setDataUrl("/");
      setMessageButton("Seguir comprando");

      // Caso 5: Otras combinaciones (ej: hospedaje + traslados)
    } else if (
      hospedaje?.length > 0 ||
      actividades?.length > 0 ||
      traslados?.length > 0
    ) {
      setDataUrl("/");
      setMessageButton("Completa tu experiencia");

      // Caso por defecto (carrito vacío)
    } else {
      setDataUrl("/");
      setMessageButton("Empieza a planificar tu viaje");
    }
  }, [dataCart]);

  const deleteHab = (index) => {
    const dataSession = dataCart;

    const newData = dataSession?.hospedaje?.filter((item, i) => i !== index);
    const setData = {
      hospedaje: newData,
      actividades: dataSession?.actividades,
      traslados: dataSession?.traslados,
    };

    if (setData?.hospedaje?.length < 1 && setData?.actividades?.length === 0) {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      window.dispatchEvent(new Event("sessionStorageChange"));
      setDataCart(setData);
      navigate("/");
    } else {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new Event("sessionStorageChange"));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      setDataCart(setData);
    }
  };

  const deleteAct = (idAct) => {
    const dataSession = dataCart;

    const newData = dataSession?.actividades?.filter(
      (item) => item?.idUnico !== idAct
    );
    const setData = {
      hospedaje: dataSession?.hospedaje,
      actividades: newData,
      traslados: dataSession?.traslados,
    };

    if (setData?.actividades?.length < 1 && setData?.hospedaje?.length === 0) {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      setDataCart(setData);
      navigate("/");
    } else {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      setDataCart(setData);
    }
  };

  const deleteTraslado = (idTraslado) => {
    const dataSession = dataCart;

    const setData = {
      hospedaje: dataSession?.hospedaje,
      actividades: dataSession?.actividades,
      traslados: [],
    };

    if (
      setData?.traslados?.length < 1 &&
      setData?.hospedaje?.length === 0 &&
      setData?.actividades?.length === 0
    ) {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      setDataCart(setData);
      navigate("/");
    } else if (
      setData?.traslados?.length === 0 &&
      setData?.hospedaje?.length < 1 &&
      setData?.actividades?.length === 0
    ) {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      setDataCart(setData);
      navigate("/");
    } else if (
      setData?.traslados?.length === 0 &&
      setData?.hospedaje?.length === 0 &&
      setData?.actividades?.length < 1
    ) {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new Event("sessionStorageChange"));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      setDataCart(setData);
      navigate("/");
    } else {
      window.dispatchEvent(new Event("sessionStorageChange"));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      setDataCart(setData);
    }
  };

  const precioHospedajes = () => {
    if (!dataCart || !dataCart?.hospedaje) return 0; // Evita errores si no hay datos
    const total = dataCart?.hospedaje?.reduce(
      (total, item) => total + item?.totalPrices,
      0
    );
    return total;
  };

  const precioActivades = () => {
    if (!dataCart || !dataCart?.actividades) return 0; // Evita errores si no hay datos

    const totalAct = dataCart?.actividades
      ?.reduce((total, item) => total + item?.totalAmount, 0)
      ?.toFixed(2);

    return totalAct;
  };

  const precioTraslados = () => {
    if (!dataCart || !dataCart?.traslados) return 0; // Evita errores si no hay datos

    const totalTras = dataCart?.traslados
      ?.reduce((total, item) => total + item?.precio, 0)
      ?.toFixed(2);

    return totalTras;
  };

  const deleteUrlSession = () => {
    window.dispatchEvent(new Event("sessionStorageChange"));
    window.dispatchEvent(new CustomEvent("cartUpdated"));
    sessionStorage.removeItem("urlSession");
  };

  const agregarCheckRateAlCart = () => {
    const habitacionesConRate = dataCart?.hospedaje?.map((item) => {
      const habitacionMatch = checkRates?.find(
        (h) => h?.habitacion?.code === item?.idHab
      );

      // Si se encuentra el rate correspondiente, lo añadimos al item
      if (habitacionMatch) {
        return {
          ...item,
          comentario: habitacionMatch?.habitacion?.rates?.[0]?.rateComments, // o habitacionMatch completo si necesitas más info
        };
      }
      return item; // si no hay match, lo dejamos igual
    });

    const newCart = {
      ...dataCart,
      hospedaje: habitacionesConRate,
    };

    // Guardar en sessionStorage y actualizar estado
    sessionStorage.setItem("datosReserva", JSON.stringify(newCart));
    window.dispatchEvent(new Event("sessionStorageChange"));
    window.dispatchEvent(new CustomEvent("cartUpdated"));
    setDataCart(newCart);
  };
  return (
    <>
    <ScrollToTopRoute />
    <div className="container position-relative px-4 px-lg-0 px-sm-0" style={{ marginTop: "50px" }}>
      {dataCart?.hospedaje?.length > 0 ||
      dataCart?.actividades?.length > 0 ||
      dataCart?.traslados?.length > 0 ? (
        <Row>
          <Col lg={6} className="pb-5 text-lg-start text-center">
            <h1 className={"CongratsTitle fw-bold"}>
              Felicidades, estás a un paso de iniciar tu aventura.
            </h1>

            <p className="text-break-mobile" style={{ fontSize: "20px" }}>
              ¿Alguna duda? Comunícate y con gusto te acompañamos durante tu
              compra:{" "}
              <Link style={{ fontSize: "20px" }} to={"tel: 998 218 9740"}>
                998 218 9740
              </Link>
            </p>
          </Col>

          <Col
            lg={6}
            sm={12}
            xs={12}
            className="pb-5 text-lg-start d-flex gap-3 align-items-start text-center flex-wrap"
          >
            {dataCart?.hospedaje?.length == 0 && (
              <Link
                to={`/alojamientos?t=destino&id=${
                  dataCart?.actividades?.[0]?.codedestino ||
                  dataCart?.traslados?.[0]?.codedestino
                }&in=${
                  dataCart?.actividades?.[0]?.checkin ||
                  dataCart?.traslados?.[0]?.checkIn
                }&out=${
                  dataCart?.actividades?.[0]?.checkout ||
                  dataCart?.traslados?.[0]?.checkOut
                }&hab=1&pax1=${
                  dataCart?.actividades?.[0]?.paxes?.[0]?.adults ||
                  dataCart?.traslados?.[0]?.numAdultos
                }|${dataCart?.actividades?.[0]?.paxes?.[0]?.minors || 0}|${
                  dataCart?.actividades?.[0]?.paxes?.[0]?.ages
                    ?.map((age) => age)
                    .join(",") || 0
                }`}
                onClick={deleteUrlSession}
              >
                <Button
                  className={"btnPreventa w-auto border-0"}
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  Descubre hoteles para tu viaje
                </Button>
              </Link>
            )}
            {dataCart?.hospedaje?.length == 0 &&
              (dataCart?.actividades?.length == 0 ||
                dataCart?.traslados?.length == 0) && (
                <span style={{ fontSize: "25px"}}></span>
              )}
            {dataCart?.actividades?.length == 0 && (
              <Link
                to={`/experiencias-resultado?t=destination&id=${
                  dataCart?.hospedaje?.[0]?.codedestino ||
                  dataCart?.traslados?.[0]?.codedestino
                }&in=${
                  dataCart?.hospedaje?.[0]?.checkIn ||
                  dataCart?.traslados?.[0]?.checkIn
                }&out=${
                  dataCart?.hospedaje?.[0]?.checkOut ||
                  dataCart?.traslados?.[0]?.checkOut
                }&pax=${
                  dataCart?.hospedaje?.[0]?.paxes?.[0]?.num_adultos ||
                  dataCart?.traslados?.[0]?.numAdultos
                }|21,21|${
                  dataCart?.hospedaje?.[0]?.paxes?.[0]?.num_menores?.toString() ||
                  0
                }|${
                  dataCart?.hospedaje?.[0]?.paxes?.[0]?.edad_menores.replace(
                    "|",
                    ","
                  ) || 0
                }`}
                onClick={deleteUrlSession}
              >
                <Button
                  className={"btnPreventa w-auto border-0"}
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  Descubre experiencias para tu viaje
                </Button>
              </Link>
            )}
            {dataCart?.actividades?.length == 0 &&
            dataCart?.traslados?.length == 0 ? (
              <span style={{ fontSize: "25px" }}></span>
            ) : (
              <></>
            )}
            {dataCart?.traslados?.length == 0 && (
              <Link to={"/traslados"} onClick={deleteUrlSession}>
                <Button
                  className={"btnPreventa w-auto border-0"}
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  Descubre traslados para tu viaje
                </Button>
              </Link>
            )}
          </Col>
          <Col
            lg={12}
            className="text-center mb-4"
            style={{
              fontSize: "20px",
              padding: "10px",
              background: "#696a6c",
              borderRadius: "20px",
              boxShadow: "rgb(0 0 0 / 20%) 10px 10px 10px 5px",
              color: "#fff",
            }}
          >
            <span className="fw-bold">
              Tiempo para completar tu reserva
            </span>{" "}
            {/* <span className="fw-bold">
              Tiempo restante para completar tu reserva
            </span>{" "} */}
            <ReservationTimer isCheckout={true} />
          </Col>
          {dataCart?.hospedaje?.length > 0 && (
            <Col lg={12}>
              <Row className="justify-content-center">
                <Col lg={12}>
                  <h2 className="fw-bold">Hotel:</h2>
                </Col>
                {dataCart?.hospedaje?.map((info, index) => {
                  return (
                    <div key={index + 1}>
                      <Row
                        key={index + 1}
                        style={{
                          padding: "20px",
                          //border: "2px solid #005cff",
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                          marginBottom: "20px",
                          boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.37)",
                        }}
                      >
                        <Col lg={12}>
                          <h2>Habitación {index + 1}</h2>
                        </Col>
                        <Col lg={3} className="d-none d-sm-block d-lg-block">
                          <img src={info?.img} className="w-100" alt="" />
                        </Col>
                        <Col lg={8}>
                          <Row>
                            <Col lg={7} style={{ fontSize: "18px" }}>
                              <div className="pt-3 pt-lg-0">
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Habitacion:{" "}
                                  </span>
                                  {info?.nombreHab}
                                </p>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Hotel:
                                  </span>{" "}
                                  {info?.nombreHotel}
                                </p>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Destino:
                                  </span>{" "}
                                  {info?.destino}
                                </p>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Plan de alimentos:
                                  </span>{" "}
                                  {info?.nombrePlan}
                                </p>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Precio de la habitacion:
                                  </span>{" "}
                                  {Currency(info?.totalPrices)}{" "}
                                  <span style={{ fontSize: "14px" }}>MXN</span>
                                </p>
                              </div>
                            </Col>
                            <Col lg={5} style={{ fontSize: "18px" }}>
                              <div>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Check in:
                                  </span>{" "}
                                  {FormatDate(info?.checkIn)}
                                </p>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Check out:
                                  </span>{" "}
                                  {FormatDate(info?.checkOut)}
                                </p>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Adultos:
                                  </span>{" "}
                                  {info?.paxes?.[index]?.num_adultos}
                                </p>
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Menores:
                                  </span>{" "}
                                  {info?.paxes?.[index]?.num_menores}{" "}
                                  <span className="text-secondary fw-lighter">
                                    | Edades:
                                  </span>{" "}
                                  {info?.paxes?.[index]?.edad_menores
                                    ? info?.paxes?.[
                                        index
                                      ]?.edad_menores?.replace("|", ", ")
                                    : 0}
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={12}>
                          <div className="pt-3">
                            <h3>Politicas de cancelación</h3>

                            <div
                              dangerouslySetInnerHTML={{
                                __html: info?.cancellationText,
                              }}
                            />
                            <p>
                              {" "}
                              Fecha y hora calculados en base a la hora local en
                              destino.{" "}
                            </p>
                          </div>
                          <div>
                            {info?.rateComments && (
                              <>
                                <h3>Comentarios</h3>
                                <p
                                  className={"CommentsDesktop"}
                                  style={{ fontSize: "18px", textAlign: "justify" }}
                                >
                                  {info?.rateComments}
                                </p>
                              </>
                            )}
                            <Accordion
                              className={"CommentsMobile mb-3"}
                              defaultActiveKey="0"
                            >
                              <Accordion.Item eventKey="0">
                                <Accordion.Header>Comentarios</Accordion.Header>
                                <Accordion.Body>
                                  <p style={{ fontSize: "18px", textAlign: "justify" }}>
                                    {info?.rateComments}
                                  </p>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </div>
                        </Col>
                        <Col lg={12} className="d-flex justify-content-end">
                          <Button
                            className="btn-danger d-flex justify-content-end"
                            onClick={() => deleteHab(index)}
                          >
                            Eliminar
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </Row>
            </Col>
          )}
          {dataCart?.actividades?.length > 0 && (
            <Col lg={12}>
              <Row className="justify-content-center">
                <Col lg={12}>
                  <h2 className="fw-bold">Actividad</h2>
                </Col>
                {dataCart?.actividades?.map((info, index) => (
                  <>
                    <Row
                      style={{
                        padding: "20px",
                        //border: "2px solid #005cff",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        marginBottom: "20px",
                        boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.37)",
                      }}
                    >
                      <Col lg={12} key={index + 1}>
                        <h2>{info?.nombreActividad}</h2>
                      </Col>
                      <Col lg={4} className="d-none d-sm-block d-lg-block">
                        <img
                          src={`${info?.imagenExp}`}
                          className="w-100"
                          alt=""
                        />
                      </Col>
                      <Col lg={8}>
                        <Row>
                          <Col lg={7}>
                            <div className="pt-3">
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Paquete:{" "}
                                </span>
                                {info?.nombreModalidad}
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Destino:
                                </span>{" "}
                                {info?.destino}
                              </p>
                              {info?.promoDateFrom && (
                                <p className="fw-bolder">
                                  <span className="text-secondary fw-lighter">
                                    Descuento:
                                  </span>{" "}
                                  {info?.promoCode} disponible desde{" "}
                                  {FormatDate(info?.promoDateFrom)} hasta el{" "}
                                  {FormatDate(info?.promoDateTo)}
                                </p>
                              )}
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Total del paquete:
                                </span>{" "}
                                {Currency(info?.totalAmount)}
                                <span style={{ fontSize: "14px" }}> MXN</span>
                              </p>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="pt-3">
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Fecha:
                                </span>{" "}
                                {FormatDate(info?.selectedDate)}
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Adulto(s):
                                </span>{" "}
                                {info?.totalAdultos}
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Menor(es):
                                </span>{" "}
                                {info?.totalMenores}{" "}
                                <span className="text-secondary fw-lighter">
                                  | Edad(es):
                                </span>{" "}
                                {info?.edadesMenoresArray?.join(",")}
                              </p>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <div className="pt-3">
                              <h3>Politicas de cancelacion</h3>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: info?.cancellationText,
                                }}
                              />
                              <p>
                                {" "}
                                Fecha y hora calculados en base a la hora local
                                en destino.{" "}
                              </p>
                              {/* <p style={{ fontSize: "17px" }}>
                              Aplica penalidad a partir del{" "}
                              <strong>
                                {info?.cancellationDateFrom}
                              </strong>
                              .
                              <strong>
                                {" "}
                                {Currency(
                                  info?.cancellationAmount
                                )}{" "}
                                <span style={{ fontSize: "14px" }}>MXN</span>
                              </strong>{" "}
                              de penalidad por cancelación.
                            </p> */}
                            </div>
                          </Col>
                          <Col lg={12} className="d-flex justify-content-end">
                            <Button
                              className="btn-danger d-flex justify-content-end"
                              onClick={() => deleteAct(info?.idUnico)}
                            >
                              Eliminar
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                ))}
              </Row>
            </Col>
          )}
          {dataCart?.traslados?.length > 0 && (
            <Col lg={12}>
              <Row className="justify-content-center">
                <Col lg={12}>
                  <h2 className="fw-bold">Traslados</h2>
                </Col>
                {dataCart?.traslados?.map((info, index) => (
                  <>
                    <Row
                      style={{
                        padding: "20px",
                        //border: "2px solid #005cff",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        marginBottom: "20px",
                        boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.37)",
                      }}
                    >
                      <Col lg={12} key={index + 1}>
                        <h2>
                          {info?.transferData?.transferType === "SHARED"
                            ? "COMPARTIDO"
                            : info?.transferData?.transferType === "PRIVATE"
                            ? "PRIVADO"
                            : info?.transferData?.transferType}{" "}
                          | {info?.transferData?.vehicle?.name} -{" "}
                          {info?.transferData?.category?.name} (
                          {info?.transferData?.direction === "DEPARTURE"
                            ? "SALIDA"
                            : info?.transferData?.direction === "ARRIVAL"
                            ? "LLEGADA"
                            : info?.transferData?.direction}
                          )
                        </h2>
                      </Col>
                      <Col lg={4} className="d-none d-sm-block d-lg-block">
                        <img
                          src={`${info?.transferData?.content?.images?.[0]?.url}`}
                          className="w-100"
                          alt=""
                        />
                      </Col>
                      <Col lg={8}>
                        <Row>
                          <Col lg={7} style={{ fontSize: "18px" }}>
                            <div className="pt-0 pt-sm-3 pt-lg-3">
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  {info?.transferData?.pickupInformation?.from
                                    ?.type === "ATLAS"
                                    ? "Hotel: "
                                    : info?.transferData?.pickupInformation
                                        ?.from?.type === "IATA"
                                    ? "Aeropuerto: "
                                    : info?.transferData?.pickupInformation
                                        ?.from?.type === "PORT"
                                    ? "Puerto: "
                                    : info?.transferData?.pickupInformation
                                        ?.from?.type === "STATION"
                                    ? "Estación: "
                                    : ""}
                                </span>
                                {
                                  info?.transferData?.pickupInformation?.from
                                    ?.description
                                }
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  {info?.transferData?.pickupInformation?.to
                                    ?.type === "ATLAS"
                                    ? "Hotel: "
                                    : info?.transferData?.pickupInformation?.to
                                        ?.type === "IATA"
                                    ? "Aeropuerto: "
                                    : info?.transferData?.pickupInformation?.to
                                        ?.type === "PORT"
                                    ? "Puerto: "
                                    : info?.transferData?.pickupInformation?.to
                                        ?.type === "STATION"
                                    ? "Estación: "
                                    : ""}
                                </span>{" "}
                                {
                                  info?.transferData?.pickupInformation?.to
                                    ?.description
                                }
                              </p>

                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Fecha{" "}
                                  {info?.transferData?.direction === "DEPARTURE"
                                    ? "salida"
                                    : info?.transferData?.direction ===
                                      "ARRIVAL"
                                    ? "llegada"
                                    : info?.transferData?.direction}
                                  :{" "}
                                </span>
                                {info?.transferData?.pickupInformation?.date !=
                                null
                                  ? FormatDate(
                                      info?.transferData?.pickupInformation
                                        ?.date
                                    )
                                  : ""}
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Hora{" "}
                                  {info?.transferData?.direction === "DEPARTURE"
                                    ? "salida"
                                    : info?.transferData?.direction ===
                                      "ARRIVAL"
                                    ? "llegada"
                                    : info?.transferData?.direction}
                                  :
                                </span>{" "}
                                {info?.transferData?.pickupInformation?.time
                                  ? FormatHours(
                                      info?.transferData?.pickupInformation
                                        ?.time
                                    )
                                  : ""}
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Total de{" "}
                                  {info?.transferData?.direction === "DEPARTURE"
                                    ? "salida"
                                    : info?.transferData?.direction ===
                                      "ARRIVAL"
                                    ? "llegada"
                                    : info?.transferData?.direction}
                                  :
                                </span>{" "}
                                {Currency(info?.precio)}
                                <span style={{ fontSize: "14px" }}> MXN</span>
                              </p>
                            </div>
                          </Col>
                          <Col lg={4} style={{ fontSize: "18px" }}>
                            <div className="pt-0 pt-sm-3 pt-lg-3">
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Equipaje:
                                </span>{" "}
                                {
                                  info?.transferData?.content
                                    ?.transferDetailInfo?.[3]?.description
                                }
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Adulto(s):
                                </span>{" "}
                                {info?.dataSearch?.adults}
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Menor(es):
                                </span>{" "}
                                {info?.dataSearch?.children}
                              </p>
                              <p className="fw-bolder">
                                <span className="text-secondary fw-lighter">
                                  Infante(s):
                                </span>{" "}
                                {info?.dataSearch?.infants}
                              </p>
                            </div>
                            <p>Precio fijo, para todos los viajeros.</p>
                          </Col>
                          <Col lg={12} style={{ fontSize: "18px" }}>
                            <span>
                              -{" "}
                              {
                                info?.transferData?.content
                                  ?.transferDetailInfo?.[1]?.description
                              }{" "}
                            </span>
                            <span>
                              -
                              {
                                info?.transferData?.content
                                  ?.transferDetailInfo?.[2]?.description
                              }{" "}
                            </span>
                            <br />
                            <p className="m-0 mb-2 pt-2 pt-sm-3 pt-lg-3">
                              - Tiempo máximo de espera a la llegada:{" "}
                              {
                                info?.transferData?.content
                                  ?.transferDetailInfo?.[0]?.description
                              }{" "}
                            </p>
                          </Col>
                          <Col lg={12}>
                            <div className="pt-3">
                              <h3>Políticas de cancelación</h3>

                              <div
                                style={{ fontSize: "18px" }}
                                dangerouslySetInnerHTML={{
                                  __html: info?.cancellationText,
                                }}
                              />
                              <p style={{ fontSize: "18px" }}>
                                {" "}
                                Fecha y hora calculados en base a la hora local
                                en destino.{" "}
                              </p>
                              {/* <p style={{ fontSize: "17px" }}>
                             Aplica penalidad a partir del{" "}
                             <strong>
                               {info?.transferData?.cancellationDateFrom}
                             </strong>
                             .
                             <strong>
                               {" "}
                               {Currency(
                                 info?.transferData?.cancellationAmount
                               )}{" "}
                               <span style={{ fontSize: "14px" }}>MXN</span>
                             </strong>{" "}
                             de penalidad por cancelación.
                           </p> */}
                            </div>
                          </Col>
                          <Col lg={12} className="d-flex justify-content-end">
                            <Button
                              className="btn-danger d-flex justify-content-end"
                              onClick={() =>
                                deleteTraslado(info?.transferData?.id)
                              }
                            >
                              Eliminar
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                ))}
              </Row>
            </Col>
          )}
          <Col lg={12}>
            <Row
              className="justify-content-end"
              style={{
                padding: "20px",
                //border: "2px solid #005cff",
                borderRadius: "10px",
                backgroundColor: "#fff",
                marginBottom: "20px",
                boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.37)",
              }}
            >
              <Col lg={12}>
                <h2
                  className="fw-bold"
                  style={{
                    display: "inline-block",
                    borderBottom: "2px solid #005cff",
                    paddingBottom: "10px",
                    marginBottom: "15px",
                  }}
                >
                  Total a pagar
                </h2>
              </Col>
              {dataCart?.hospedaje?.length > 0 && (
                <Col lg={3}>
                  <h4>
                    <strong>Tu hospedaje en</strong>{" "}
                    <span className="text-secondary">
                      {" "}
                      <br />
                      {dataCart?.hospedaje?.[0]?.destino}
                    </span>
                  </h4>
                </Col>
              )}
              {dataCart?.actividades?.length > 0 && (
                <Col lg={4}>
                  <h4>
                    <strong>Tu actividad en</strong> <br />
                    <span className="text-secondary">
                      {dataCart?.actividades?.[0]?.destino}
                    </span>
                  </h4>
                </Col>
              )}
              {dataCart?.traslados?.length > 0 && (
                <Col lg={3}>
                  <h4>
                    <strong>Tu traslado en</strong>{" "}
                    <span className="text-secondary">
                      {" "}
                      <br />
                      {
                        dataCart?.traslados?.[0]?.transferData
                          ?.pickupInformation?.from?.description
                      }
                    </span>
                  </h4>
                </Col>
              )}
              <Col lg={3}>
                <h3>
                  <span style={{ fontSize: "20px", lineHeight: "35px" }}>
                    Reserva:
                  </span>{" "}
                  <br />
                  {dataCart?.hospedaje?.length > 0 && (
                    <>
                      <span
                        style={{
                          fontSize: "18px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Hospedaje:{" "}
                        <span>
                          <span style={{ fontWeight: "bold" }}>
                            {Currency(totalHospedaje)}
                          </span>{" "}
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            MXN
                          </span>
                        </span>
                      </span>
                    </>
                  )}
                  {dataCart?.actividades?.length > 0 && (
                    <>
                      <span
                        style={{
                          fontSize: "18px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Actividad:{" "}
                        <span>
                          <span style={{ fontWeight: "bold" }}>
                            {Currency(totalActividades)}
                          </span>{" "}
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            MXN
                          </span>
                        </span>
                      </span>
                    </>
                  )}
                  {dataCart?.traslados?.length > 0 && (
                    <>
                      <span
                        style={{
                          fontSize: "18px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Traslado:{" "}
                        <span>
                          <span style={{ fontWeight: "bold" }}>
                            {Currency(totalTraslados)}
                          </span>{" "}
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            MXN
                          </span>
                        </span>
                      </span>
                    </>
                  )}
                  <hr
                    style={{
                      color: "#005cff",
                      opacity: "1",
                      width: "100%",
                    }}
                  />
                  <hr
                    style={{
                      color: "#005cff",
                      opacity: "1",
                      width: "100%",
                    }}
                  />
                  <span
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Total:{" "}
                    <span>
                      <span style={{ fontWeight: "bold" }}>
                        {Currency(totalReserva)}{" "}
                      </span>
                      <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                        MXN
                      </span>
                    </span>
                  </span>
                </h3>
              </Col>
              <Col lg={2} className="d-flex flex-column">
                <Button
                  className={"btnPreventa w-auto mt-auto border-0"}
                  onSelect={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    agregarCheckRateAlCart();
                    navigate("/checkout");
                  }}
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <div className="container">
          <Link to={"/"} onClick={deleteUrlSession}>
            <div className="boton-seguir-preventa mb-2">
              <span
                className={"btnPreventa btn text-light"}
                href="/"
                style={{ width: "fit-content" }}
              >
                Seguir comprando
              </span>
            </div>
          </Link>

          <div className="row">
            <div className="col-lg-12 text-lg-start text-center">
              <div className="title-prevent">
                <h2 className="text-black">
                  Tu carrito está vacio, añade alguna habitación y/o
                  experiencia.
                </h2>
                <p>
                  ¿Alguna duda? Comunícate y con gusto te acompañamos durante tu
                  compra:{" "}
                  <a className="text-black" href="tel:998 218 9740">
                    998 218 9740
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="mt-4 mb-2" style={{ textAlign: "center" }}>
            <img src={EmptyCart} alt="Carrito vacio" style={{ width: "50%" }} />
          </div>
        </div>
      )}
    </div>
    </>
  );
};
